<template>
  <page class="stakeoutshipment-app" v-loading="loading">
    <nav-bar slot="header"></nav-bar>
    <page-content slot="content">
      <page-bar>
        <page-bar-item :label="$route.meta.label"></page-bar-item>
      </page-bar>

      <el-row class="special__layout-left">
        <el-col :span="arrowLayIsShow?8:0" v-show="arrowLayIsShow" style="margin-right: 30px;">
          <special-head
            :params="params"
            style="margin-bottom: 20px;"
            @handleReset="handleReset"
            @handleSearch="handleSearch"
          ></special-head>
          <special-table
            @handleRowItem="handleRowItem"
            @handleCurrentChange="handleCurrentChange"
            :page-config="pageConfig"
            :list="list"
          ></special-table>
        </el-col>
        <el-col :span="arrowLayIsShow?15:24">
          <portlet class="form-query" hide-title="true">
            <el-tabs v-model="activeName">
              <el-tab-pane label="基本信息" name="1">
                <tab-info
                  @handleRefreshFabrich="handleRefreshFabrich"
                  :read-only="readOnly"
                  :info="info"
                ></tab-info>
              </el-tab-pane>
              <el-tab-pane label="工艺图示" name="2">
                <tab-instruction :read-only="readOnly" :info="info"></tab-instruction>
              </el-tab-pane>
              <el-tab-pane label="工艺说明" name="5">
                <tab-other :read-only="readOnly" :info="info"></tab-other>
              </el-tab-pane>
              <el-tab-pane label="尺寸指示" name="3">
                <tab-description @updateImportCraft="updateImportCraft" :read-only="readOnly" :info="info"></tab-description>
              </el-tab-pane>
              <el-tab-pane label="特殊工艺说明" name="4">
                <tab-special :read-only="readOnly" :info="info"></tab-special>
              </el-tab-pane>
              <el-tab-pane label="颜色/尺码网格" name="6">
                <tab-grid
                  @handleRefreshColor="handleRefreshColor"
                  :read-only="readOnly"
                  :info="info"
                ></tab-grid>
              </el-tab-pane>
            </el-tabs>
          </portlet>
        </el-col>
        <div class="special__arrow" @click="handleLayoutIsShow" :class="arrowLayIsShow?'check':''"></div>
      </el-row>

      <multiline-dialog class="product-process" fullscreen width="50%" title="选择打印模板" ref="multiline-dialog" @handleSave="handleDialogSave">
        <base-radio
          :multiple="true"
          v-model="dialogConfig.selectValue"
          :options="dialogConfig.options"
        ></base-radio>
        <base-radio
          :multiple="true"
          v-model="zoomDialogConfig.selectValue"
          :options="zoomDialogConfig.options"
          label="打印比例："
        ></base-radio>
      </multiline-dialog>
    </page-content>

    <page-footer slot="footer" class="bom-button">
      <base-button
        @click="handleEdit"
        :disabled="btnGroup[5]"
        :isRoot="true"
        type="primary"
        class="el-button--small"
        v-if="operateMap['SPECIAL_PROCESS_EDIT']"
      >{{readOnly?'编辑':'取消'}}</base-button>
      <template v-if="readOnly">
        <el-button
          @click="handleSelectBtn('PROTECHNICS_RECHECK')"
          class="el-button--small"
          :disabled="btnGroup[2]"
          v-if="operateMap['PROTECHNICS_RECHECK']"
        >申请反审</el-button>
        <el-button
          @click="handleSelectBtn('PROTECHNICS_RETURN')"
          class="el-button--small"
          :disabled="btnGroup[3]"
          v-if="operateMap['SPECIAL_PROCESS_RETURN']"
        >退回</el-button>
        <el-button
          @click="handleSelectBtn('PROTECHNICS_CHECK')"
          type="primary"
          class="el-button--small"
          :disabled="btnGroup[4]"
          v-if="operateMap['SPECIAL_PROCESS_AUDIT']"
        >审核</el-button>
      </template>
      <template v-else>
        <base-button type="primary" @click="handleSave" :disabled="btnGroup[5] || saveLoading" :loading="saveLoading">保存</base-button>
      </template>
      <el-button
        @click="handleSelectBtn('PROTECHNICS_SUBMIT')"
        type="primary"
        class="el-button--small"
        :disabled="btnGroup[1]"
      >提交</el-button>
      <base-button type="primary" @click="handlePrint" :disabled="!info.materialCode">打印</base-button>
    </page-footer>
  </page>
</template>
<script>
import _ from 'lodash'
import specialHead from "./modules/special-head.vue";
import specialTable from "./modules/special-table.vue";
import tabInfo from "./modules/tab-info.vue";
import tabInstruction from "./modules/tab-instruction.vue";
import tabDescription from "./modules/tab-description.vue";
import tabSpecial from "./modules/tab-special.vue";
import tabOther from "./modules/tab-other.vue";
import tabGrid from "./modules/tab-grid.vue";
import {
  formatTableHead,
  formatTableCTX,
  formatJoinColor,
  formatGradInfo
} from "./modules/mixins";
import PageFooter from "components/page/PageFooter.vue";
export default {
  components: {
    specialHead,
    specialTable,
    tabInfo,
    tabInstruction,
    tabDescription,
    tabSpecial,
    tabOther,
    tabGrid,
    "page-footer": PageFooter
  },
  computed: {
    // README https://www.tapd.cn/53765550/prong/stories/view/1153765550001009457
    btnGroup() {
      let keysDisabled = {
        1: true, // 提交
        2: true, // 反审
        3: true, // 退回
        4: true, // 审核
        5: true // 保存
      };
      const isEdit = false;
      const status = this.info.status;
      if (status == null || status == undefined) return keysDisabled;
      // 尺寸
      const sizeItemList = this.info.sizeItemList.length === 0;
      // 工艺
      const detailItemList = this.info.detailItemList.length === 0;
      const isEmpty = sizeItemList || detailItemList;
      //保存
      if (
        status == 0 ||
        status == 4 ||
        status == "" ||
        status === undefined ||
        status === null
      ) {
        keysDisabled[5] = false;
      }
      // 提交
      if (
        (status == 0 ||
          status == 4 ||
          status == "" ||
          status === undefined ||
          status === null) &&
        !isEmpty
      ) {
        keysDisabled[1] = false;
      }
      // 审核
      if (status == 1 && !isEmpty) {
        keysDisabled[4] = false;
      }
      // 反审
      if ((status == 1 || status == 2) && !isEmpty) {
        keysDisabled[2] = false;
      }
      // 退回
      if ((status == 1 || status == 3) && !isEmpty) {
        keysDisabled[3] = false;
      }

      // if (status === undefined || status === null) return keysDisabled;
      // if (status == 0) {
      // 	keysDisabled[5] = false;
      // 	!isEmpty && (keysDisabled[1] = false);
      // } else if (status == 1 && !isEmpty) {
      // 	keysDisabled[2] = false;
      // 	keysDisabled[3] = false;
      // 	keysDisabled[4] = false;
      // } else if (status == 2 && !isEmpty) {
      // 	keysDisabled[2] = false;
      // } else if (status == 3 && !isEmpty) {
      // 	keysDisabled[3] = false;
      // } else if (status == 4) {
      // 	keysDisabled[5] = false;
      // 	keysDisabled[1] = false;
      // }
      // if(isEmpty) {
      //     keysDisabled[5] = false;
      // }
      // console.log(keysDisabled)
      return keysDisabled;
    },
    operateMap() {
      let operateList = JSON.parse(window.sessionStorage.getItem("operateList"));
      let resurlMap = _.groupBy(operateList,'resPrivilege')
      return resurlMap
    },
  },
  methods: {
    handleReset() {
      this.params = {
        materialCode: null,
        brands: null,
        years: null,
        periods: null,
        materialDesc: null,
        ProductionCategory: null,
        S001: null,
        waveCode: null,
      };
      this.pageConfig = {
        pageSize: 10,
        pageNumber: 1,
        total: 0
      }
    },
    handleRefreshColor() {
      this.$apis.autoAPi
        .PROTECHNICS_GETLASTGRIDSIZE({ materialCode: this.info.materialCode })
        .done(res => {

          let productDemandsList = []
          let demandsSizeList = []
          let demandsGridList = []
          let demandList = []
          let uniqObj = {}
          // 根据后端接口返回的数据 生成适用的数据机构=>颜色/尺码的表头和内容
          if(res.data && res.data.length) {
            demandList = res.data.sort((a,b) => a.sizeCode - b.sizeCode)
            let demandGrpup = this.$utils.groupBy(res.data, item => item.colorCode + '/' + item.colorName) 
            productDemandsList.push([null, ...this.$utils.uniq(demandList.map(item => item.sizeName))])
            this.$utils.forIn(demandGrpup, (value, key) => {
              // demandsGridList.push({
              //   colorCode: value[0].colorCode,
              //   colorName: value[0].colorName,
              // })
              productDemandsList.push([key, ...value.map(item => item.originQty)])
            })
            //  刷新后重新获取数据
            // demandList.forEach(item => {
            //   if(!uniqObj[item.sizeCode + '' + item.sizeName]) {
            //     uniqObj[item.sizeCode + '' + item.sizeName] = true
            //     demandsSizeList.push({
            //       sizeCode: item.sizeCode,
            //       sizeName: item.sizeName
            //     })
            //   }
            // })
          }
          // if (this.info.productDemandsList.length > 0) {
          //   this.info.originDemandsList = productDemandsList;
          //   //	 转换成需要的数据格式
          //   this.info.originDemandsListHead = formatTableHead(
          //     productDemandsList
          //   );
          //   this.info.originDemandsListCtx = formatTableCTX(
          //     productDemandsList
          //   );
          // } else {
            this.info = {
              ...this.info,
              // originDemandsList: productDemandsList,
              // productDemandsList: productDemandsList,
              // demandsSizeList: demandsSizeList,
              // demandsGridList: demandsGridList,
              // originDemandsListHead: formatTableHead(
              //   productDemandsList
              // ),
              // originDemandsListCtx: formatTableCTX(productDemandsList),
              productDemandsListHead: formatTableHead(
                productDemandsList
              ),
              productDemandsListCtx: formatTableCTX(productDemandsList),
              demandProdList: demandList
            };
            if(!res.data.demandList) {
              this.info.originDemandsListHead = formatTableHead(
                productDemandsList
              )
              this.info.originDemandsListCtx = formatTableCTX(
                productDemandsList
              )
            }
          // }
        });
    },
    handleLayoutIsShow() {
      this.arrowLayIsShow = !this.arrowLayIsShow;
    },
    handleEdit() {
      this.readOnly = !this.readOnly;
    },
    handleRefreshFabrich() {
      this.$apis.autoAPi
        .PROTECHNICS_GETLASTFABRIC({ materialCode: this.info.materialCode })
        .done(res => {
          this.info.fabricList = res.data || [];
        });
    },
    handleSelectBtn(apiName) {
      let status;
      switch (apiName) {
        case 'PROTECHNICS_RETURN':
          status = '4'
          break;
        case 'PROTECHNICS_RECHECK':
          status = '3'
          break;
        case 'PROTECHNICS_CHECK':
          status = '2'
          break;
        case 'PROTECHNICS_SUBMIT':
          status = '1'
          break;
        default:
          break;
      }
      this.$apis.autoAPi.POST_TECHNICS_PRO_STATUS_UPDATE({
        status,
        id: this.info.id,
        userId: this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.adminUserName
      }).done(res => {
        this.handleRowItem(this.selectItem);
      })
    },
    handleSave() {
      // if (this.info.sizeItemList.length < 1) return this.$message({type: 'warning', message: '尺寸指示最少要一行数据'})
      let result = this.info.sizeItemList.find(item => !item.itemNo)
      if(result) {
        return this.$message({type: 'warning', message: '尺寸指示序号不能为空'})
      }
      let fabricResult = this.info.fabricList.find(item => !item.fabricName)
      if(fabricResult) {
        return this.$message({type: 'warning', message: '面料名称不能为空'})
      }
      let demandProdList = []
      if(this.info.productDemandsListCtx && this.info.productDemandsListCtx.length) {
        let sizeMap = {}
        _.each(this.info.demandProdList, head => {
          sizeMap[head.sizeName] = head.sizeCode
        })
        console.log('sizeMap:', sizeMap)
        _.each(this.info.productDemandsListCtx,  ctxList => {
          let colors = ''
          _.each(ctxList, (ctx, idx) => {
            if(idx == 0) {
              colors = ctx ? ctx.split('/') : ''
            } else {
              let colorObj = {}
              colorObj.colorCode = colors ? colors[0] : ''
              colorObj.colorName = colors ? colors[1] : ''
              colorObj.originQty = ctx
              colorObj.sizeCode = sizeMap[this.info.productDemandsListHead[idx]]
              colorObj.sizeName = this.info.productDemandsListHead[idx]
              demandProdList.push(colorObj)
            }
          })
        })

      }
      this.saveLoading = true
      this.$apis.autoAPi
        .POST_TECHNICS_PRO_SAVE_DETAIL({
          ...this.info,
          demandProdList,
          demandList: this.info.demandList && this.info.demandList.length ? this.info.demandList : demandProdList,
          pattern: this.info.pattern ? this.info.pattern.map(item => item.code).join(',') : '',
          userId: this.$store.state.userInfo.id,
          userName: this.$store.state.userInfo.adminUserName
        })
        .done(res => {
          this.readOnly = true;
          this.saveLoading = false
          this.handleRowItem(this.selectItem);
          this.handleCurrentChange(this.pageConfig.pageNumber);
        }).fail(err => {
          this.readOnly = true;
          this.saveLoading = false
        });
    },
    handleRowItem(row) {
      this.selectItem = row;
      // this.$store.dispatch('getCraftConfig', {id: row.id,materialCode: row.materialCode})
      this.$apis.autoAPi
        .POST_TECHNICS_PRO_DETAIL_GET({
          id: row.id,
          materialCode: row.materialCode
        })
        .done(res => {
          const {suggestion = ''} = res?.data
          this.readOnly = true;
          let originDemandsList = []
          // 根据后端接口返回的数据 生成适用的数据机构=>颜色/尺码的表头和内容
          if(res.data.demandList && res.data.demandList.length) { // 原始订单数
            let demandList = res.data.demandList.sort((a,b) => a.sizeCode - b.sizeCode)
            let demandGrpup = this.$utils.groupBy(res.data.demandList, item => item.colorCode + '/' + item.colorName) 
            originDemandsList.push([null, ...this.$utils.uniq(demandList.map(item => item.sizeName))])
            this.$utils.forIn(demandGrpup, (value, key) => {
              originDemandsList.push([key, ...value.map(item => item.originQty)])
            })
          }
          let productDemandsList = []
          if(res.data.demandProdList && res.data.demandProdList.length) { // 生产数
            let demandProdList = res.data.demandProdList.sort((a,b) => a.sizeCode - b.sizeCode)
            let demandGrpup = this.$utils.groupBy(res.data.demandProdList, item => item.colorCode + '/' + item.colorName) 
            productDemandsList.push([null, ...this.$utils.uniq(demandProdList.map(item => item.sizeName))])
            this.$utils.forIn(demandGrpup, (value, key) => {
              productDemandsList.push([key, ...value.map(item => item.originQty)])
            })
          }
          if(res.data.sizeItemList && res.data.sizeItemList.length) { // 处理跳码字段为空时,设置默认值
            let codonSelected = res.data.codonSelected
            if(codonSelected) {
              if(codonSelected.includes('确认尺寸')) {
                codonSelected = codonSelected.substr(4)
              }
              res.data.sizeItemList.forEach(item => {
                item.gradMap = {
                  ...item.gradMap,
                  [codonSelected]: item.sizeMap[codonSelected] == undefined ? item.sizeMap[`确认尺寸${codonSelected}`] : item.sizeMap[codonSelected]
                }
              })
            }
          }
          this.info = {
            ...res.data,
            originDemandsListHead: formatTableHead(originDemandsList), // 原始需求列表
            originDemandsListCtx: formatTableCTX(originDemandsList),
            productDemandsListHead: formatTableHead(
              productDemandsList
            ), // 生产需求列表
            productDemandsListCtx: formatTableCTX(productDemandsList),
            sizeItemList: formatGradInfo(
              res.data.sizeItemList,
              res.data.gradCodeList,
              res.data.sizeCodeList
            ),
            suggestion: (this.params.brands === '1' && !suggestion) ? '以物料卡为准' : suggestion,
            pieceList: res.data.pieceList || [],
            fabricList: res.data.fabricList || [],
            detailItemList: res.data.detailItemList || [],
            updatedTime: this.$utils.formatTime(res.data.updatedTime),
            pattern: res.data.pattern ? res.data.pattern.split(",")
              .map((item) => ({
                comment: item,
                code: item,
              })) : []
          };
          console.log(this.info);
          // console.log(this.sourceInfo);
        })
        .fail(err => {
          console.log(err)
          debugger
        });
    },
    // 导入工艺后更新数据
    updateImportCraft(data) {
      this.info = data
    },

    handleCurrentChange(val) {
      this.pageConfig.pageNumber = val;
      this.handleSearch(this.params);
    },
    handlePrint() {
      this.$refs["multiline-dialog"].handleIsShow(true);

      return;
      // this.$confirm("选择类型为毛织", "提示", {
      //   confirmButtonText: "毛织",
      //   cancelButtonText: "非毛织",
      //   type: "warning"
      // })
      //   .then(() => {
      //     window.open(
      //       `${window.location.origin}/trendy-print?pkId=${pkId}&materialCode=${materialCode}&page=productionProcess&isWoollen=1`
      //     );
      //   })
      //   .catch(() => {
      //     window.open(
      //       `${window.location.origin}/trendy-print?pkId=${pkId}&materialCode=${materialCode}&page=productionProcess&isWoollen=0`
      //     );
      //   });
    },
    handleSearch(params) {
      this.$apis.autoAPi
        .POST_QUERY_TECHNICS_PRO_PAGE({
          ...params,
          pageSize: this.pageConfig.pageSize,
          pageNumber: this.pageConfig.pageNumber
        })
        .done(res => {
          this.list = res.data.records;
          this.pageConfig.total = res.data.rowsCount;
        })
        .fail(err => {});
    },
    handleDialogSave() {
      const { id, materialCode } = this.info;
      const selectValue = this.dialogConfig.options.find(
        item => item.comment === this.dialogConfig.selectValue
      );
      if(!selectValue) {
        return this.$message.warning('请选择打印模板')
      }
      const zoomSelectValue = this.zoomDialogConfig.options.find(
        item => item.comment === this.zoomDialogConfig.selectValue
      );
      const code = selectValue.code == 4 ? 3 : selectValue.code;

      const zoom = zoomSelectValue.code;
      window.open(
        formatUrl(
          id,
          materialCode,
          code,
          selectValue.query.table1Size,
          selectValue.query.table2Size,
          zoom
        )
      );

      function formatUrl(id, materialCode, type, table1Size, table2Size,zoom) {
        return `${window.location.origin}/trendy-print?id=${id}&materialCode=${materialCode}&page=productionProcess&isWoollen=${type}&table1Size=${table1Size}&table2Size=${table2Size}&zoom=${zoom}`;
      }
    }
  },
  mounted() {},
  data() {
    return {
      saveLoading: false,
      loading: false,
      list: [],
      arrowLayIsShow: true,
      readOnly: true,
      info: {},
      sourceInfo: {},
      selectItem: {},
      params: {
        materialCode: null,
        brands: null,
        years: null,
        periods: null,
        materialDesc: null,
        ProductionCategory: null,
        S001: null,
        waveCode: null
      },
      activeName: "1",

      pageConfig: {
        pageSize: 10,
        pageNumber: 1,
        total: 0
      },

      dialogConfig: {
        selectValue: null,
        options: [
          {
            code: "11",
            comment: "梭织（正面25行，反面7行）",
            query: {
              table1Size: 25,
              table2Size: 7
            }
          },
          {
            code: "12",
            comment: "梭织（正面25行，反面10行）",
            query: {
              table1Size: 25,
              table2Size: 10
            }
          },
          {
            code: "13",
            comment: "梭织（正面35行，反面7行）",
            query: {
              table1Size: 35,
              table2Size: 7
            }
          },
          {
            code: "14",
            comment: "梭织（正面35行，反面10行）",
            query: {
              table1Size: 35,
              table2Size: 10
            }
          },
          {
            code: "15",
            comment: "梭织简版（正面25行）",
            query: {
              table1Size: 25,
              table2Size: 10
            }
          },
          {
            code: "16",
            comment: "梭织简版（正面35行）",
            query: {
              table1Size: 35,
              table2Size: 10
            }
          },
          {
            code: "1",
            comment: "毛织",
            query: {}
          },
          {
            code: "11",
            comment: "梭织（正面19行，反面7行）",
            query: {
              table1Size: 19,
              table2Size: 7
            }
          },
          {
            code: "17",
            comment: "梭织简版 新（正面25行）",
            query: {
              table1Size: 25,
              table2Size: 10
            }
          },
          {
            code: "17",
            comment: "梭织简版 新（正面35行）",
            query: {
              table1Size: 35,
              table2Size: 10
            }
          },
          // {
          //   code: "2",
          //   comment: "梭织(正面25行)",
          //   query: {
          //     table1Size: 25
          //   }
          // },
          // {
          //   code: "2",
          //   comment: "梭织(正面35行)",
          //   query: {
          //     table1Size: 35
          //   }
          // },
          // {
          //   code: "3",
          //   comment: "梭织(反面7行)",
          //   query: {
          //     table2Size: 7
          //   }
          // },
          // {
          //   code: "4",
          //   comment: "梭织(反面10行)",
          //   query: {
          //     table2Size: 10
          //   }
          // }
          // {
          //   code: "4",
          //   comment: "梭织(多尺码模板反面)",
          //   query: {
          //     table2Size: 10
          //   }
          // }
        ]
      },

      zoomDialogConfig: {
        selectValue: "100%",
        options: [
          {
            code: "100",
            comment: "100%",
           
          },
          {
            code: "85",
            comment: "85%",
          
          },
          {
            code: "70",
            comment: "70%",
           
          }
        ]
      }
    };
  }
};
</script>

<style scoped lang="scss">
.stakeoutshipment-app {
  .special__layout-left {
    .special__arrow {
      position: fixed;
      left: 0px;
      top: 20%;
      height: 140px;
      width: 22px;
      background-color: #b7bbbf;
      border-radius: 17px 0 0 17px !important;
      &::before {
        content: "";
        border: 1px solid #fff;
        border-left: none;
        border-bottom: none;
        width: 12px;
        height: 12px;
        top: 50%;
        position: absolute;
        left: 50%;
        transform: translate(-9px, -6px) rotate(45deg);
      }
      &.uncheck {
      }
      &.check {
        &::before {
          transform: translate(-3px, -6px) rotate(-135deg);
        }
      }
    }
  }
}
</style>
<style>
.product-process .el-radio {
  width: 20% !important;
  margin-bottom: 15px !important;
}
</style>
